import type { AuthenticatedUser } from "@/common/keycloak/keycloak"
import { ApiSession } from "@/common/auth/utils"
import { pluginRegistry } from "@/PluginRegistry";
import { usePermissions } from "@/common/hooks/use-permissions";

type HomeProps = {
  authUser: AuthenticatedUser
  apiSession: ApiSession | null
  onLogout: () => Promise<void>
}

export function Subscriptions(_props: HomeProps) {

  const { hasPagePermission } = usePermissions()

  if (!hasPagePermission("Subscriptions")) {
    return "You do not have permission to view this page.  If you believe this is an error, please contact your administrator.";
  }

  try {
    var Control = pluginRegistry.resolve("subscriptionsControl");
    return <Control authUser={_props.authUser} apiSession={_props.apiSession} onLogout={_props.onLogout} />
  } catch (error) {
    // TODO: Monitor this happening
    console.error(error);
    return "There was an issue loading this page (Plugin not registered).";
  }
}
